import React, { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userId, isLoaded } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait until Clerk is loaded before checking authentication
    if (isLoaded && !userId) {
      // Redirect to sign-in page if not authenticated
      navigate('/sign-in');
    }
  }, [isLoaded, userId, navigate]);

  // Don't render anything until Clerk is loaded and auth status is confirmed
  if (!isLoaded) {
    return <div>Loading...</div>; // Or a spinner component
  }

  // If authenticated, render the children components (the protected page)
  if (userId) {
    return <>{children}</>;
  }

  // If not authenticated and redirecting, render null or loading
  // (The useEffect hook handles the navigation)
  return <div>Redirecting to sign-in...</div>; // Or null
};

export default ProtectedRoute;
